export const fontConfig = {
  FiraSans: {
    100: {
      normal: "FiraSans-Thin",
      italic: "FiraSans-ThinItalic",
    },
    200: {
      normal: "FiraSans-Light",
      italic: "FiraSans-LightItalic",
    },
    300: {
      normal: "FiraSans-Light",
      italic: "FiraSans-LightItalic",
    },
    400: {
      normal: "FiraSans-Regular",
      italic: "FiraSans-Italic",
    },
    500: {
      normal: "FiraSans-Medium",
      italic: "FiraSans-MediumItalic",
    },
    600: {
      normal: "FiraSans-SemiBold",
      italic: "FiraSans-SemiBoldItalic",
    },
    700: {
      normal: "FiraSans-Bold",
      italic: "FiraSans-BoldItalic",
    },
    800: {
      normal: "FiraSans-Bold",
      italic: "FiraSans-BoldItalic",
    },
    900: {
      normal: "FiraSans-Black",
      italic: "FiraSans-BlackItalic",
    },
  },
};

export const fonts = {
  heading: "FiraSans",
  body: "FiraSans",
  mono: "FiraSans",
};

export const appFontsToLoad = {
  "FiraSans-Black": require("../assets/fonts/FiraSans-Black.ttf"),
  "FiraSans-BlackItalic": require("../assets/fonts/FiraSans-BlackItalic.ttf"),
  "FiraSans-Bold": require("../assets/fonts/FiraSans-Bold.ttf"),
  "FiraSans-BoldItalic": require("../assets/fonts/FiraSans-BoldItalic.ttf"),
  "FiraSans-ExtraBold": require("../assets/fonts/FiraSans-ExtraBold.ttf"),
  "FiraSans-ExtraBoldItalic": require("../assets/fonts/FiraSans-ExtraBoldItalic.ttf"),
  "FiraSans-ExtraLight": require("../assets/fonts/FiraSans-ExtraLight.ttf"),
  "FiraSans-ExtraLightItalic": require("../assets/fonts/FiraSans-ExtraLightItalic.ttf"),
  "FiraSans-Italic": require("../assets/fonts/FiraSans-Italic.ttf"),
  "FiraSans-Light": require("../assets/fonts/FiraSans-Light.ttf"),
  "FiraSans-LightItalic": require("../assets/fonts/FiraSans-LightItalic.ttf"),
  "FiraSans-Medium": require("../assets/fonts/FiraSans-Medium.ttf"),
  "FiraSans-MediumItalic": require("../assets/fonts/FiraSans-MediumItalic.ttf"),
  "FiraSans-Regular": require("../assets/fonts/FiraSans-Regular.ttf"),
  "FiraSans-SemiBold": require("../assets/fonts/FiraSans-SemiBold.ttf"),
  "FiraSans-SemiBoldItalic": require("../assets/fonts/FiraSans-SemiBoldItalic.ttf"),
  "FiraSans-Thin": require("../assets/fonts/FiraSans-Thin.ttf"),
  "FiraSans-ThinItalic": require("../assets/fonts/FiraSans-ThinItalic.ttf"),
};
